import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

//components
import Layout from "../../layouts/Layout";
import { capitalCase, snakeCase } from "change-case";
import InfoSectionLeft from "../../components/InfoSection/InfoSectionLeft/InfoSectionLeft";
import InfoSectionRight from "../../components/InfoSection/InfoSectionRight/InfoSectionRight";
import INFO_SECTION from "../../constants/about-info-section";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import TagLineSection from "../../components/TagLineSection/TagLineSection";
import TableLayoutSection from "../../components/TableLayoutSeciton/TableLayoutSection";
import SectionDivider from "../../components/SectionDivider/SectionDivider";
import GrayCardsWrapper from "../../components/GrayCardsWrapper/GrayCardsWrapper";
import LogoGridSection from "../../components/LogoGridSection/LogoGridSection";
import SEO from "../../components/Seo/Seo";

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({ push: PropTypes.func }).isRequired,
};

const AboutUs = ({ history, location }) => {
  let pageName = location.pathname.substring(1);
  pageName = capitalCase(pageName);
  return (
    <Layout page={pageName} location={location}>
      <SEO
        title="About Rapid Data Labs | Experts in Data & Cloud Solutions"
        description="Learn about Rapid Data Labs, a trusted IT consulting company specializing in data engineering, cloud solutions, and scalable software development."
        url="https://www.rapiddatalabs.com/about-us"
      />
      <Breadcrumb title={pageName} fromPage={snakeCase(pageName)} />
      <InfoSectionLeft content={INFO_SECTION} className={"p-b-0"} />

      <div className="about-desc">
        <section className="page-details-wrapper p-b-0">
          <div className="container">
            <div className="page-details-grid d-grid">
              <div className="page-details-left">
                <div className="page-details-contents">
                  <div className="d-grid">
                    <div className="page-cnt-mdl-right">
                      <p>
                        Our founder <strong>Ms. Pinal Boghara</strong>, an
                        entrepreneur and leader with a proven track record of
                        financial and operational excellence — post graduated
                        with Master's in Finance. She focuses especially on
                        building an organizational culture based on partnership,
                        trust, transparent communication and company values.
                        <br />
                        Pinal outlines the company’s vision and mission, fosters
                        a customer-centric culture, and leads the modernization
                        initiatives across the entire organization.
                        <br />
                        Her interest in business dynamics drove herself to move
                        very quickly to a engineering and then propelled her
                        career towards management that lead him to start a
                        venture leading tech solutions that drive sustained
                        organisation growth.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <InfoSectionRight
        content={INFO_SECTION}
        className={"p-t-0 m-b-30"}
        gridClass={"m-t-30"}
      />

      <SectionDivider className={"m-b-20"} />
      <TagLineSection
        content={
          "We’re committed delivering world class services and solutions to our clients to drive customer value and results."
        }
      />
      <TableLayoutSection content={INFO_SECTION} />
      <SectionDivider />

      <GrayCardsWrapper content={INFO_SECTION} />

      <SectionDivider />
      <LogoGridSection content={INFO_SECTION} />
    </Layout>
  );
};

AboutUs.propTypes = propTypes;
export default withRouter(AboutUs);
